
import React, { useState, FC, useEffect } from "react";
// import Modal from "../modal";
// import * as Utils from '../../utils/EllowUtils'
import "./dropdown.scss";
// import AvailablitySettings from "./availablitySettings";
// import { projectSkills } from "../../utils/CONSTANTS";


// interface to declare all our prop types
export type InputProps = {
  id?: string | null, 
  onClick?: any,
  props?: any,
  drop?:any
}

export const AvailablityDropdown: FC<InputProps> = ({
  children,
  id,
  onClick,
  props,
  drop,
  ...rest
}) => { 


  const [value, setValue] = useState<any>()
  const [date, setDate] = useState<any>()
  
  // const profileMetadata = JSON.parse(localStorage.getItem("profile_metadata") || "{}") || {}
 

  
  // const OnClick = (data:any) =>{
  //     setValue(data)
  // }
  let avialabilityDate = Number(localStorage.getItem('date') )
  let finalDate = new Date(avialabilityDate ? avialabilityDate : '') .toDateString()  
  let availabilityId = localStorage.getItem('availablityId')
  let availabilityWeek = localStorage.getItem('weeks')
  
  useEffect(() => {
  if(availabilityId){
    setValue(availabilityId)      
  }
  }, [availabilityId])

  useEffect(() => {
    if(drop === true){
      toggleClass()   
     }

  }, [drop])
  
  
  const OnClick = (data: number) =>{
      
      if(data === 1 || data == 2 || data == 3 || data === 4 || data===5){
        setValue(data)
        let value = {
          "availabilityId" : data 
        }
        onClick(value)
      }

      if( data === 2){
        setDate(true)
      }
      toggleClass();
  }

  const onClose = () => {
    setDate(false)
  }
  
  const selectedValue = (data:any) => {
    setValue(data.availabilityId)
    onClick(data)
    setDate(false)
  }

  const [isActive, setActive] = useState(false);

  const toggleClass = () => {
    setActive(!isActive);
  };


  return (
    <>
      <div className={isActive ? 'activeDropdown availablityDropdown' : 'availablityDropdown'} > 
        {value == 1 && <button className="btn" onClick={() => {OnClick(1)}} ><i className="green"></i>Available Immediately</button>}
        {value == 2 && <button className="btn" onClick={() => {OnClick(2)}} ><i className="green"></i>Available by {finalDate}</button>}
        {value == 3 && <button className="btn" onClick={() => {OnClick(3)}} ><i className="green"></i>Available in {availabilityWeek} weeks after offer is received</button>}
        {value == 4 && <button className="btn" onClick={() => {OnClick(4)}} ><i className="red"></i>Unavailable For Jobs</button>}
        {value == 5 && <button className="btn" onClick={() => {OnClick(5)}} ><i className="red"></i>Unavailable For Jobs</button>} 


        {/* <div className="availablityOption">
          <div className="item-list" onClick={() => {OnClick(1)}}><i className="green"></i>Available Immediately</div>
          <div className="item-list" onClick={() => {OnClick(4)}}><i className="red"></i>Unknown</div>
          <div className="item-list" onClick={() => OnClick(2)}><i className="green"></i>Add Availablity</div>
          <div className="item-list" onClick={() => OnClick(5)}><i className="red"></i>Unavailable For Jobs </div>
        </div>
       */}
      </div>
      
      {/* {date && <Modal title={"Availablity Settings"} onClose={onClose} size="xsmall">
          <AvailablitySettings onClose={onClose} onClick={selectedValue}/>
      </Modal> } */}
     
    </>
  );
}


export default AvailablityDropdown;
